import type { Maybe } from '~/types/graphql';

export const mapBarChartDataSeries = <T extends { type?: string; totalCount?: number }>(
  data: Maybe<Pick<T, 'type' | 'totalCount'>>[] | undefined,
  formatKey: (key: string) => string,
): { key: string; value: number }[] => {
  return data
    ? data
        .filter(
          (item): item is Pick<T, 'type' | 'totalCount'> =>
            !!item && !!item.type && item.totalCount !== undefined,
        )
        .map(({ type, totalCount }) => ({
          key: type ? formatKey(type) : '',
          value: totalCount ?? 0,
        }))
    : [];
};
